import { ChartItem } from '@common/components/charts';
import { useState, useCallback, useMemo } from 'react';

export const useChartInteractions = (data: ChartItem[]) => {
    const [hoveredName, setHoveredName] = useState<string | undefined>(
        undefined,
    );

    const activeIndex = useMemo(
        () =>
            hoveredName
                ? data.findIndex((item) => item.name === hoveredName)
                : -1,
        [data, hoveredName],
    );

    const onHover = useCallback((name: string | undefined) => {
        setHoveredName(name);
    }, []);

    const isFocused = useCallback(
        (name: string) => hoveredName === null || hoveredName === name,
        [hoveredName],
    );

    return {
        hoveredName,
        activeIndex,
        onHover,
        isFocused,
    };
};
